export default __webpack_public_path__ + "static/media/close-icon-red.75bd0301.svg";